var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductsetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 3.6C9.01797 3.6 9.6 3.01797 9.6 2.3C9.6 1.58203 9.01797 1 8.3 1C7.58203 1 7 1.58203 7 2.3C7 3.01797 7.58203 3.6 8.3 3.6Z",
    fill: "#163663"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 8.79971C9.01797 8.79971 9.6 8.21768 9.6 7.49971C9.6 6.78174 9.01797 6.19971 8.3 6.19971C7.58203 6.19971 7 6.78174 7 7.49971C7 8.21768 7.58203 8.79971 8.3 8.79971Z",
    fill: "#163663"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 14.0001C9.01797 14.0001 9.6 13.4181 9.6 12.7001C9.6 11.9822 9.01797 11.4001 8.3 11.4001C7.58203 11.4001 7 11.9822 7 12.7001C7 13.4181 7.58203 14.0001 8.3 14.0001Z",
    fill: "#163663"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsetting);
export default __webpack_public_path__ + "static/media/productsetting.dfc2b1010d76505135eae0f6cc4d6b86.svg";
export { ForwardRef as ReactComponent };